import { render, staticRenderFns } from "./DashboardChartAssignment.vue?vue&type=template&id=a78b3a30&"
import script from "./DashboardChartAssignment.vue?vue&type=script&lang=js&"
export * from "./DashboardChartAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports